import { withErrorBoundary } from 'app/components/error-boundary';
import { withDashboardLayout } from 'app/hooks/with-dashboard-layout';
import { AmplifyAuthConfiguration } from 'app/services/amplify';
import { Amplify } from 'aws-amplify';
import { ProfileOverviewScreen } from './profile-overview-screen';
Amplify.configure({ Auth: { Cognito: AmplifyAuthConfiguration } });

const ProfileOverview = withErrorBoundary(withDashboardLayout(ProfileOverviewScreen));

export default ProfileOverview;
